var _rect, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 82,
    height: 82,
    rx: 9.5,
    fill: "white",
    stroke: "#E2E4E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0391 28.126L33.1457 29.2326C35.494 26.8842 38.679 25.5649 42.0001 25.5649C45.3212 25.5649 48.5062 26.8842 50.8545 29.2326L51.9611 28.126C49.3193 25.4842 45.7362 24 42.0001 24C38.264 24 34.6809 25.4842 32.0391 28.126Z",
    fill: "#47B638"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9987 30.261C39.9225 30.2583 37.9309 31.0832 36.4648 32.5533L37.5715 33.6599C38.7456 32.4857 40.3381 31.826 41.9987 31.826C43.6592 31.826 45.2517 32.4857 46.4259 33.6599L47.5325 32.5533C46.0664 31.0832 44.0748 30.2583 41.9987 30.261Z",
    fill: "#47B638"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.4792 52.1741V49.6079L45.6666 49.003C45.459 48.9333 45.2899 48.7798 45.2007 48.5798C45.1115 48.3797 45.1101 48.1514 45.1971 47.9504L47.4792 42.6834V41.2176C47.469 38.1033 48.8904 35.157 51.3344 33.2266C53.7783 31.2962 56.9736 30.5958 60.0009 31.327V59.2176H53.74V55.3045H50.6096C48.8807 55.3045 47.4792 53.903 47.4792 52.1741Z",
    fill: "#47B638"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5217 52.1741V49.608L38.3343 49.003C38.542 48.9334 38.711 48.7799 38.8002 48.5798C38.8895 48.3798 38.8908 48.1515 38.8038 47.9504L36.5217 42.6834V41.2176C36.5217 35.5987 31.9667 31.0437 26.3478 31.0437C25.5569 31.0467 24.769 31.1417 24 31.327V59.2176H30.2609V55.3046H33.3913C35.1202 55.3046 36.5217 53.903 36.5217 52.1741Z",
    fill: "#47B638"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9988 39.6524C42.8633 39.6524 43.564 38.9516 43.564 38.0872C43.564 37.2227 42.8633 36.522 41.9988 36.522C41.1344 36.522 40.4336 37.2227 40.4336 38.0872C40.4336 38.9516 41.1344 39.6524 41.9988 39.6524Z",
    fill: "#47B638"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIcon2);
export default __webpack_public_path__ + "static/media/service-icon2.7dbcb2cdfbde1bc9c951ee419449067a.svg";
export { ForwardRef as ReactComponent };